module.exports = __webpack_public_path__ + "static/media/member (5).30e571b0.png";